module.exports = __webpack_public_path__ + "static/media/pixelated-image.685bc39b.png";